export default __webpack_public_path__ + "static/media/radar-vertical.ff44774d.svg";